'use strict';
import isObject from 'lodash/isObject';
import isString from 'lodash/isString';

export const DomainUtilitiesImport = [
  DomainUtilities];

export function camelCase(name) {
  return name.replace(/([\:\-\_]+(.))/g, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  });
}

export function dashSeparate(name) {
  return name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
}

export function isLink(object) {
  return isObject(object)
    && isString(object.id) && object.id.length > 0
    && isString(object.collection) && object.collection.length > 0;
}

/**
 *
 * @param {Object} instance
 * @param {Boolean} [includeValue=false]
 * @return {?DomainLink}
 */
export function asLink(instance, includeValue=false) {
  if (isLink(instance)) {
    return Object.assign({}, instance);
  } else if (isObject(instance) && instance.$id && instance.$class) {
    const link = {
      id: instance.$id,
      collection: instance.$class.COLLECTION,
    };
    if (includeValue)
      link.value = instance.toString();
    return link;
  } else {
    return null;
  }
}

function DomainUtilities() {
  DomainUtilities.camelCase = camelCase;

  DomainUtilities.dashSeparate = dashSeparate;

  DomainUtilities.intercepted = function (fn) {

    function interceptedFunction() {
      var result, i;

      if (fn.$$interceptors && fn.$$interceptors.before) {
        for (i = 0; i < fn.$$interceptors.before.length; i++) {
          fn.$$interceptors.before[i].apply(this, arguments);
        }
      }

      result = fn.apply(this, arguments);

      if (fn.$$interceptors && fn.$$interceptors.after) {
        for (i = 0; i < fn.$$interceptors.after.length; i++) {
          fn.$$interceptors.after[i].apply(this, arguments);
        }
      }

      return result;
    }

    Object.defineProperty(interceptedFunction, '$$interceptors', {value: {before: [], after: []}});

    /**
     * when can be one of ['before', 'after', 'around']
     */
    interceptedFunction.addInterceptor = function (when, interceptor) {
      if (typeof interceptor === 'function') {
        interceptedFunction.$$interceptors[when].push(interceptor);
      } else {
        throw new Error('interceptor must be a function!');
      }
    };

    return interceptedFunction;
  };

  return DomainUtilities;
}



// WEBPACK FOOTER //
// ./src/js/_libs/angular-domain/DomainUtilities.js